import { useState, KeyboardEvent } from 'react';
import { TextInput, ActionIcon, Group } from '@mantine/core';
import { IconSend } from '@tabler/icons-react';

interface ConversaInputProps {
  onSendMessage: (text: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export const ConversaInput = ({
  onSendMessage,
  disabled = false,
  placeholder = 'Digite uma mensagem...',
}: ConversaInputProps) => {
  const [text, setText] = useState('');

  const handleSend = () => {
    const trimmedText = text.trim();
    if (trimmedText && !disabled) {
      onSendMessage(trimmedText);
      setText('');
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Group gap="xs" p="sm" style={{ borderTop: '1px solid #e9ecef' }}>
      <TextInput
        flex={1}
        value={text}
        onChange={(e) => setText(e.currentTarget.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        radius="xl"
        styles={{
          input: {
            backgroundColor: '#f8f9fa',
          },
        }}
      />
      <ActionIcon
        size="lg"
        radius="xl"
        color="blue"
        variant="filled"
        onClick={handleSend}
        disabled={disabled || !text.trim()}
        aria-label="Enviar mensagem"
      >
        <IconSend size={18} />
      </ActionIcon>
    </Group>
  );
};
